import React from "react";
import { Bar } from "react-chartjs-2";
import { makeStyles } from "@mui/styles";
import { trackPromise } from "react-promise-tracker";

import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Typography,
  colors,
  useTheme,
  Grid,
} from "@mui/material";

import axios from "axios";
import { useEffect, useState } from "react";

const SalesByProvince = ({
  dayShow,
  weekShow,
  monthShow,
  threeMonthsShow,
  sixMonthsShow,
}) => {
  const theme = useTheme();
  const [result, setResult] = useState({ sales: { labels: [], datasets: [] } });
  const [percentage, setPercentage] = useState(
    new Array(3).fill({ MB: 0, ON: 0, QC: 0, NL: 0, NS: 0, SK: 0, NB: 0 }),
  );

  useEffect(() => {
    trackPromise(
      axios
        .get(
          "http://192.168.14.53:8000/api/provinceSales/periodic_province_sales",
          {
            params: {
              daily: dayShow,
              weekly: weekShow,
              monthly: monthShow,
              threeMonths: threeMonthsShow,
              sixMonths: sixMonthsShow,
            },
          },
        )
        .then((res) => {
          setResult(res.data);
          setPercentage(res.data.percentage);
        }),
    );
  }, [weekShow, monthShow, threeMonthsShow, sixMonthsShow]);

  const options = {
    animation: false,
    cutoutPercentage: 70,
    layout: { padding: 0 },
    legend: {
      display: true,
    },
    maintainAspectRatio: false,
    responsive: true,
  };

  const PROVINCES = ["MB", "NB", "NL", "NS", "ON", "QC", "SK"];
  const COLORS = ["#0D830F", "#86086D", "#3a34eb"];

  return (
    <Card
      sx={{
        height: "100%",
        borderRadius: 2.5,
        border: "1px solid",
        borderColor: "divider",
        boxShadow: "0 1px 2px rgba(16, 24, 40, 0.05)",
      }}
    >
      <CardHeader
        title="Sales by province"
        titleTypographyProps={{ variant: "subtitle1", fontWeight: 600 }}
      ></CardHeader>

      <Divider />
      <CardContent>
        <Box
          sx={{
            height: 500,
            position: "relative",
          }}
        >
          <Bar data={result.sales} options={options} />
        </Box>

        <Box
          sx={{
            p: 1,
            textAlign: "left",
          }}
        ></Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          {PROVINCES.map((province) => (
            <Box
              key={province}
              sx={{
                p: 1,
                textAlign: "center",
              }}
            >
              <Typography color="textPrimary" variant="body1">
                {province}
              </Typography>
              {percentage.map((yearData, index) => (
                <Typography
                  key={index}
                  style={{ color: COLORS[index] }}
                  variant="h4"
                >
                  {yearData[province]}%
                </Typography>
              ))}
            </Box>
          ))}
        </Box>
      </CardContent>
    </Card>
  );
};

export default SalesByProvince;
